/**
 * Colours of the monitoring charts (the admin is dark only; the chart surface is the card, #171717).
 *
 * - Categorical slots (pods, compared series) in a fixed order, never cycled; validated as a set with the
 *   dataviz palette validator on #171717: lightness band, chroma, adjacent CVD separation (worst 17.3)
 *   and contrast all pass.
 * - Status colours are reserved for state (OK calm grey, warning amber, serious orange, critical red)
 *   and never reused for a plain series - same rule as the rest of the admin: colour marks problems.
 */
export const SERIES = ["#3987e5", "#199e70", "#9085e9", "#d95926"] as const;

/** the light step of the primary hue: the p50 companion of a p95 line */
export const SERIES_LIGHT = "#86b6ef";

export const STATUS = {
  good: "#0ca30c",
  warning: "#fab219",
  serious: "#ec835a",
  critical: "#d03b3b",
} as const;

/** calm marks: passed / neutral volume */
export const NEUTRAL = {
  strong: "#8a8984",
  mid: "#6b6a66",
  soft: "#45443f",
  /** "usual" baselines and reference lines */
  baseline: "#a8a7a0",
} as const;

export const seriesColor = (index: number) => SERIES[index] ?? NEUTRAL.strong;

/** verdict colours: OK is calm, problems carry the status colours */
export const VERDICT_COLORS = {
  ok: NEUTRAL.mid,
  nok: STATUS.serious,
  invalid_photo: STATUS.warning,
  no_pizza: "#c98500",
  pending: NEUTRAL.soft,
  missing: STATUS.critical,
} as const;

export const LEVEL_COLORS = {
  error: STATUS.critical,
  warning: STATUS.warning,
  info: NEUTRAL.mid,
} as const;

export const HTTP_CLASS_COLORS = {
  s2: NEUTRAL.mid,
  s3: NEUTRAL.soft,
  s4: STATUS.warning,
  s5: STATUS.critical,
} as const;
